import { useContext, useEffect, useState } from "react";
import AOS from 'aos';
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import OneTestimony from "../ones/OneTestimony";

export default function TestimonialsBanner() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([appContext.getAllTestimonials()]);
    setReady(true);
  }

  useEffect(() => {
    init();
    AOS.init({ duration: 1000, once: true });
  }, []);

  const list = appContext.allTestimonials || [];
  const isSingle = list.length <= 1;
  
  // Only duplicate if we actually need to slide
  const displayList = isSingle ? list : [...list, ...list, ...list];

  const sliderStyles = `
    @keyframes marquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(calc(-380px * ${list.length})); } 
    }
    .testimonial-slider-viewport {
      overflow: hidden;
      padding: 40px 0;
      position: relative;
      width: 100%;
      display: flex;
      justify-content: ${isSingle ? 'center' : 'flex-start'};
    }
    .testimonial-track {
      display: flex;
      gap: 30px;
      width: max-content;
      /* Only animate if more than 1 item exists */
      animation: ${isSingle ? 'none' : 'marquee 30s linear infinite'};
    }
    .testimonial-track:hover {
      animation-play-state: paused;
    }
    /* Edge Fades - Only show if sliding */
    .testimonial-slider-viewport::before, .testimonial-slider-viewport::after {
      content: "";
      position: absolute;
      top: 0;
      width: 100px;
      height: 100%;
      z-index: 2;
      pointer-events: none;
      display: ${isSingle ? 'none' : 'block'};
    }
    .testimonial-slider-viewport::before {
      left: 0;
      background: linear-gradient(to right, #f8fafc, transparent);
    }
    .testimonial-slider-viewport::after {
      right: 0;
      background: linear-gradient(to left, #ffffff, transparent);
    }
  `;

  if (!ready) return <div className="py-5">{getInlineLoader()}</div>;

  return (
    <section className="py-5" style={{ background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)" }}>
      <style>{sliderStyles}</style>
      
      <div className="container text-center mb-4" data-aos="fade-up">
        <span style={{ color: "#3b82f6", fontWeight: "700", fontSize: "0.8rem", textTransform: "uppercase", letterSpacing: "2px" }}>
          Testimonials
        </span>
        <h2 style={{ fontWeight: 800, color: "#0f172a", marginTop: "10px" }}>What Our Partners Say</h2>
      </div>

      <div className="testimonial-slider-viewport">
        <div className="testimonial-track">
          {displayList.map((item, i) => (
            <div key={i} style={{ width: "380px", padding: "0 15px", flexShrink: 0 }}>
              <OneTestimony data={item} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}